import type { TRuleWithTheme } from 'styles/theme';

export const button: TRuleWithTheme = ({ theme }) => ({
    padding: 0,
});

export const icon: TRuleWithTheme = () => ({
    transform: 'rotate(90deg)',
});
